// import { useGetInfo, useGetLegalInfo } from "../api/auth/queris.js";

// // ===== تابع کمکی برای دریافت نقش کاربر =====
// const getCookie = (name: string): string | null => {
//     const match: any = document.cookie.match(
//         new RegExp('(^| )' + name + '=([^;]+)')
//     );
//     return match ? decodeURIComponent(match[2]) : null;
// };

// export const getUserRole = (): string => {
//     const localRole = localStorage.getItem("userRoleCartStreet");
//     if (localRole) return localRole;

//     const cookieRole = getCookie("userRoleCartStreet");
//     if (cookieRole) return cookieRole;

//     return "customer";
// };

// // ===== هوک واحد برای دریافت اطلاعات کاربر بر اساس نقش =====
// export const useUserInfo = () => {
//     const userRole = getUserRole();
//     const isLegal = userRole === "legal";

//     const legalQuery = useGetLegalInfo();
//     const customerQuery = useGetInfo();

//     // بر اساس نقش، یکی از کوئری‌ها رو فعال کن
//     return isLegal ? legalQuery : customerQuery;
// };
// core/hooks/useUserInfo.ts

import { useQuery } from "@tanstack/react-query";
import { GetInfoApi, GetLegalInfoApi } from "../api/auth/api.js";
import { authKeys } from "../api/auth/key.js";

const getCookie = (name: string): string | null => {
    const match: any = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
};

export const getUserRole = (): string | null => {
    const localRole = localStorage.getItem("userRoleCartStreet");
    if (localRole) return localRole;

    const cookieRole = getCookie("userRoleCartStreet");
    if (cookieRole) return cookieRole;

    return null; // ← ✅ دیگه دیفالت "customer" برنمیگردونه
};

export const useUserInfo = () => {
    // ✅ نقش رو از localStorage میخونیم
    // اگه null باشه یعنی کاربر لاگین نیست
    const userRole = getUserRole();
    const isLegal = userRole === "legal";
    const isCustomer = userRole === "customer";

    // ✅ از localStorage استفاده نکن برای token
    // چون ممکنه httponly باشه
    // بذار خود API تصمیم بگیره

    const legalQuery = useQuery({
        queryKey: authKeys.legalInfo(),
        queryFn: () => GetLegalInfoApi(),
        enabled: isLegal,              // ← فقط وقتی نقش legal هست
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        retry: false,
    });

    const customerQuery = useQuery({
        queryKey: authKeys.userInfo(),
        queryFn: () => GetInfoApi(),
        enabled: isCustomer,           // ← فقط وقتی نقش customer هست
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        retry: false,
    });

    const activeQuery = isLegal ? legalQuery : customerQuery;

    return {
        ...activeQuery,
        isLegal,
        userRole,
    };
};